import React from 'react'
import CardName from './SuperMedicalMix/CardName'

export default class SuperMedicalChild extends React.Component {
  constructor (props) {
      super (props)
      this.state = {data:props.data}
  }
  delete_action (item) {
    const newState = this.state.data;
    let indexes = newState.map((obj,index)=>{
      if(obj._id == item._id){
        return index
      }
    }).filter(isFinite)[0]

  	// if (indexes > -1) {
    	newState.splice(indexes, 1);
      this.setState({data: newState})
    // }
  }
  render () {

    let lengthData
      if(this.state.data){
        lengthData = this.state.data.length
      }
      let cardName = []

      for(var i=0; i<lengthData; i++){
        cardName.push(<CardName key={i+'1231'} keyData={i} index={'d12'+i} datos={this.state.data[i]} onDelete={(item) => {this.delete_action(item)}}/>)
      }
      return (

        <div>
        {cardName}
        </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/components/Patient/SuperMedicalChild.js